export var BUSINESS_ERROR_CODES = {
    NO_ELIGIBLE_MEMBERS_FOUND: '0010',
    EXPIRED_MEMBERSHIP: '0020',
    NOT_ELIGIBLE_MEMBERS: '0050',
    FIRST_NAME: '600004',
    ADDRESS: '600005',
    PROFANITY: '600017',
    PRIMARY_CARDHOLDER: '600025'
};
export var validErrorMessageCode = [
    BUSINESS_ERROR_CODES.NO_ELIGIBLE_MEMBERS_FOUND,
    BUSINESS_ERROR_CODES.EXPIRED_MEMBERSHIP,
    BUSINESS_ERROR_CODES.NOT_ELIGIBLE_MEMBERS
];
export var STATUS_CODE = {
    EXISTING_USER: '200',
    NEW_USER: '201',
    BUSINESS_ERROR: '422'
};
export var RESPONSE_STATUS = {
    BUSINESS_ERROR: 422,
    FORBIDDEN: 403
};
